/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppTemplateUpdateParameterMap } from '../../axios/whatsAppTemplateUpdateParameterMap'
import type {
	WhatsAppTemplateUpdateParameterMapError,
	WhatsAppTemplateUpdateParameterMapPathParams,
	WhatsAppTemplateUpdateParameterMapRequest,
	WhatsAppTemplateUpdateParameterMapResponse,
} from '../../types/WhatsAppTemplateUpdateParameterMap'

export const whatsAppTemplateUpdateParameterMapMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-templates/:templateId/parameter-map' }] as const

export type WhatsAppTemplateUpdateParameterMapMutationKey = ReturnType<
	typeof whatsAppTemplateUpdateParameterMapMutationKey
>

export type WhatsAppTemplateUpdateParameterMapVariables = {
	organisationId: WhatsAppTemplateUpdateParameterMapPathParams['organisationId']
	templateId: WhatsAppTemplateUpdateParameterMapPathParams['templateId']
	data: WhatsAppTemplateUpdateParameterMapRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::updateParameterMap */
export function useWhatsAppTemplateUpdateParameterMap<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppTemplateUpdateParameterMapResponse,
		AxiosError<WhatsAppTemplateUpdateParameterMapError>,
		WhatsAppTemplateUpdateParameterMapVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppTemplateUpdateParameterMapMutationKey(),
		mutationFn: ({ organisationId, templateId, data }: WhatsAppTemplateUpdateParameterMapVariables) =>
			whatsAppTemplateUpdateParameterMap(organisationId, templateId, data, config).then(res => res.data),
		...options,
	})
}
